import { Slide } from "@jelly/lesson";

import review from "./components/review";
import psychoacoustic from "./components/psychoacoustic";
import create from "./components/create";

const principle: Slide = {
  title: "Post Processing & Analysis",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Review Recordings" },
            { name: "Psychoacoustic Analysis" },
            { name: "Create Variants / Modifications" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], []],
      components: [review, psychoacoustic, create],
    },
  },
};

export default principle;
